import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const MiniShoppingBagContainer = styled("div")`
    color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.textColor};
    display: flex;
    flex-direction: column;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
    border-bottom-left-radius: ${({theme}) => theme.uxfabric.shape.global.popover.default.borderRadius};
    border-bottom-right-radius: ${({theme}) => theme.uxfabric.shape.global.popover.default.borderRadius};
    width: 20rem;
`

export const TotalText = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
`

export const MiniShoppingBagPriceWrapper = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-bottom: unset;
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
`

export const ItemCountWrapper = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontWeight}`};
    font-size: ${({theme}) => theme.uxfabric.global.subtitle2.fontSize};
    padding: 0.25rem 0.75rem 0.75rem;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogHeader.default.backgroundColor};
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogHeader.default.borderColor};
    border-top: unset;
    text-transform: ${({theme}) => theme.uxfabric.global.subtitle2.textTransform};
    line-height: ${({theme}) => theme.uxfabric.global.subtitle2.lineHeight};
    letter-spacing: ${({theme}) => theme.uxfabric.global.subtitle2.letterSpacing}px;
`

export const EmptyBagWrapper = styled("div")`
    height: 8.25rem;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogHeader.default.backgroundColor};
    border-width: 0 0.0625rem;
    border-style: solid;
    border-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.borderColor};
    align-items: center;
    justify-content: center;
    display: flex;
`

export const EmptyBagTextWrapper = styled("p")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => theme.uxfabric.global.body1.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.global.body1.fontWeight};
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};
`

export const CTAContainer = styled("div")`
    align-self: center;
    flex: 1 1 auto;
    font-family: ${({theme}) =>
        `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
    line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    min-height: 2.25rem;
    min-width: 8.625rem;

    && > a {
        font-family: ${({theme}) =>
            `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
        font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
        text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
        line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    }
`

export const ActionWrapper = styled("div")`
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-top: unset;
    border-radius: inherit;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 1rem 0.938rem;
    overflow: hidden;
    align-items: center;
    && > a {
        font-family: ${({theme}) => `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
        font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
        letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
        text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
        line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    }
`

export const CartItemsContainer = styled("div")`
    display: flex;
    flex-direction: column;
`

export const TotalValue = styled("p")`
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    text-transform: ${({theme}) => `${theme.uxfabric.global.body3.textTransform}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    margin: 0;
`
